export default {
  common: {
    picksHeader: {
      closeLink: 'dt.contest.gamecenter.common.picksHeader.closeLink',
      subtitle: 'dt.contest.gamecenter.common.picksHeader.subtitle',
      title: 'dt.contest.gamecenter.common.picksHeader.title',
      headerMenu: {
        container: 'dt.contest.gamecenter.common.picksHeader.headerMenu.container',
        withdraw: 'dt.contest.gamecenter.common.picksHeader.headerMenu.withdraw',
      },
    },
    header: {
      backLink: 'dt.contest.gamecenter.common.header.backLink',
    },
    marketplaceTab: {
      entriesLoadMore: 'dt.contest.gamecenter.common.marketplaceTab.entriesLoadMore',
      offersLoadMore: 'dt.contest.gamecenter.common.marketplaceTab.offersLoadMore',
      offerSettings: 'dt.contest.gamecenter.common.marketplaceTab.offerSettings',
    },
    navigation: {
      scheduled: {
        entries: 'dt.contest.gamecenter.common.navigation.scheduled.entries',
        entrants: 'dt.contest.gamecenter.common.navigation.scheduled.entrants',
        detail: 'dt.contest.gamecenter.common.navigation.scheduled.detail',
      },
      nonScheduled: {
        standings: 'dt.contest.gamecenter.common.navigation.nonScheduled.standings',
        entries: 'dt.contest.gamecenter.common.navigation.nonScheduled.entries',
        stats: 'dt.contest.gamecenter.common.navigation.nonScheduled.stats',
        detail: 'dt.contest.gamecenter.common.navigation.nonScheduled.detail',
        availability: 'dt.contest.gamecenter.common.navigation.nonScheduled.availability',
        players: 'dt.contest.gamecenter.common.navigation.nonScheduled.players',
        marketplace: 'dt.contest.gamecenter.common.navigation.nonScheduled.marketplace',
      },
      slates: 'dt.contest.gamecenter.common.navigation.slates',
    },
    picks: {
      picksCountBanner: 'dt.contest.gamecenter.common.picks.picksCountBanner',
      picksPanel: {
        picksMadeCount: 'dt.contest.gamecenter.common.picks.picksPanel.picksMadeCount',
        pick: 'dt.contest.gamecenter.common.picks.picksPanel.pick',
        clearButton: 'dt.contest.gamecenter.common.picks.picksPanel.clearButton',
        container: 'dt.contest.gamecenter.common.picks.picksPanel.container',
        submit: 'dt.contest.gamecenter.common.picks.picksPanel.submit',
      },
      postPickModal: {
        container: 'dt.contest.gamecenter.common.picks.postPickModal.container',
        closeButton: 'dt.contest.gamecenter.common.picks.postPickModal.closeButton',
        confetti: 'dt.contest.gamecenter.common.picks.postPickModal.confetti',
        title: 'dt.contest.gamecenter.common.picks.postPickModal.title',
        subtitle: 'dt.contest.gamecenter.common.picks.postPickModal.subtitle',
        pick: 'dt.contest.gamecenter.common.picks.postPickModal.pick',
        pickName: 'dt.contest.gamecenter.common.picks.postPickModal.pickName',
        actions: {
          newEntry: 'dt.contest.gamecenter.common.picks.postPickModal.actions.newEntry',
          viewMyEntries: 'dt.contest.gamecenter.common.picks.postPickModal.actions.viewMyEntries',
          continueEditing:
            'dt.contest.gamecenter.common.picks.postPickModal.actions.continueEditing',
        },
      },
      loadingOverlay: 'dt.contest.gamecenter.common.picks.loadingOverlay',
    },
    entriesScheduled: {
      entry: {
        container: 'dt.contest.gamecenter.common.entriesScheduled.entry.container',
        slate: 'dt.contest.gamecenter.common.entriesScheduled.entry.slate',
        editButton: 'dt.contest.gamecenter.common.entriesScheduled.entry.editButton',
        moreActionsButton: 'dt.contest.gamecenter.common.entriesScheduled.entry.moreActionsButton',
        withdrawButton: 'dt.contest.gamecenter.common.entriesScheduled.entry.withdrawButton',
      },
    },
    availability: {
      reportBanner: 'dt.contest.gamecenter.common.availability.reportBanner',
      reportLink: 'dt.contest.gamecenter.common.availability.reportLink',
      entryRank: 'dt.contest.gamecenter.common.availability.entryRank',
    },
  },
  teamSurvivor: {
    reviveEntryModal: 'dt.contest.gamecenter.teamSurvivor.reviveEntryModal',
    availabilityFilter: {
      control: {
        trigger: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.control.trigger',
        search: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.control.search',
        option: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.control.option',
        clear: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.control.clear',
        apply: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.control.apply',
      },
      summary: {
        pill: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.summary.pill',
        resultCount: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.summary.resultCount',
      },
      noMatches: 'dt.contest.gamecenter.teamSurvivor.availabilityFilter.noMatches',
    },
  },
  team: {
    picks: {
      sortOptionsSelect: 'dt.contest.gamecenter.team.picks.sortOptionsSelect',
      sortOption: 'dt.contest.gamecenter.team.picks.sortOption',
      skeleton: 'dt.contest.gamecenter.team.picks.skeleton',
    },
    game: {
      container: {
        SCHEDULED: 'dt.contest.gamecenter.team.game.container.scheduled',
        IN_PROGRESS: 'dt.contest.gamecenter.team.game.container.inProgress',
        FINALIZED: 'dt.contest.gamecenter.team.game.container.finalized',
        FINISHED: 'dt.contest.gamecenter.team.game.container.finished',
      },
      team: 'dt.contest.gamecenter.team.game.team',
      teamName: 'dt.contest.gamecenter.team.game.teamName',
      radioButton: 'dt.contest.gamecenter.team.game.radioButton',
      seed: 'dt.contest.gamecenter.team.game.seed',
      previewButton: 'dt.contest.gamecenter.team.game.previewButton',
    },
    gameInfo: {
      container: 'dt.contest.gamecenter.team.gameInfo.container',
      closeButton: 'dt.contest.gamecenter.team.gameInfo.closeButton',
    },
    entriesScheduled: {
      entry: {
        team: 'dt.contest.gamecenter.team.entriesScheduled.entry.team',
        teamAbbr: 'dt.contest.gamecenter.team.entriesScheduled.entry.teamAbbr',
        moreActionsButton: 'dt.contest.gamecenter.team.entriesScheduled.entry.moreActionsButton',
        withdrawButton: 'dt.contest.gamecenter.team.entriesScheduled.entry.withdrawButton',
      },
    },
    pickEm: {
      picksBar: {
        toggleExpand: 'dt.contest.gamecenter.team.pickEm.picksBar.toggleExpand',
        fullPick: {
          container: 'dt.contest.gamecenter.team.pickEm.picksBar.fullPick.container',
          teamName: 'dt.contest.gamecenter.team.pickEm.picksBar.fullPick.teamName',
          shuffleButton: 'dt.contest.gamecenter.team.pickEm.picksBar.fullPick.shuffleButton',
        },
      },
    },
    survivor: {
      standings: {
        entryRow: 'dt.contest.gamecenter.team.survivor.standings.entryRow',
      },
    },
  },
};
